var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-col',[_c('h1',[_vm._v("CRITICAL MISS: 404 Page Not Found")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }